// GROUP 
export enum MTMA_GROUP_TABLE_COLUMNS {
    NAME = 'Name',
    TIMESLOT = 'Timeslot',
    SPECIALPERIOD = 'SpecialPeriod',
    ACTIONS = 'Actions',
}

export const MTMA_GROUP_DEFAULT_SORT_COLUMN = MTMA_GROUP_TABLE_COLUMNS.NAME;
export const MTMA_GROUP_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const MTMA_GROUP_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const MTMA_GROUP_PAGE_DEFAULT_SIZE = 20;
export const MTMA_GROUP_MAX_MEMORY_SIZE = 20;

export const MTMA_GROUP_TABLE_HEADER = [
    MTMA_GROUP_TABLE_COLUMNS.NAME,
    MTMA_GROUP_TABLE_COLUMNS.TIMESLOT,
    MTMA_GROUP_TABLE_COLUMNS.SPECIALPERIOD,
    MTMA_GROUP_TABLE_COLUMNS.ACTIONS,
];


// WEEKLY_SCHEDULE 
export enum MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS {
    NAME = 'Name',
    TYPE = 'Type',
    REPETITION = 'Repetition',
    INCLUDEEXCLUDE = 'IncludeExclude',
    DETAILS = 'Details',
    TIME = 'Time',
    TEMPORARY = 'Temporary',
    ACTIONS = 'Actions',
}

export const MTMA_WEEKLY_SCHEDULE_DEFAULT_SORT_COLUMN = MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.NAME;
export const MTMA_WEEKLY_SCHEDULE_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const MTMA_WEEKLY_SCHEDULE_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const MTMA_WEEKLY_SCHEDULE_PAGE_DEFAULT_SIZE = 20;
export const MTMA_WEEKLY_SCHEDULE_MAX_MEMORY_SIZE = 20;

export const MTMA_WEEKLY_SCHEDULE_TABLE_HEADER = [
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.NAME,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.TYPE,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.REPETITION,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.INCLUDEEXCLUDE,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.DETAILS,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.TIME,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.TEMPORARY,
    MTMA_WEEKLY_SCHEDULE_TABLE_COLUMNS.ACTIONS,
];

//SPECIAL_PLANNING
export enum MTMA_SPECIAL_PLANNING_TABLE_COLUMNS {
    NAME = 'name',
    PROGRAM = 'program',
    ACTIONS = 'actions',
}

export const MTMA_SPECIAL_PLANNING_DEFAULT_SORT_COLUMN = MTMA_SPECIAL_PLANNING_TABLE_COLUMNS.NAME;
export const MTMA_SPECIAL_PLANNING_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const MTMA_SPECIAL_PLANNING_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const MTMA_SPECIAL_PLANNING_PAGE_DEFAULT_SIZE = 20;
export const MTMA_SPECIAL_PLANNING_MAX_MEMORY_SIZE = 20;

export const MTMA_SPECIAL_PLANNING_TABLE_HEADER = [
    MTMA_SPECIAL_PLANNING_TABLE_COLUMNS.NAME,
    MTMA_SPECIAL_PLANNING_TABLE_COLUMNS.PROGRAM,
    MTMA_SPECIAL_PLANNING_TABLE_COLUMNS.ACTIONS,
];


export const MTMA_WEEKDAYS_STRING_ID = [
    'WEEKDAY_MONDAY',
    'WEEKDAY_TUESDAY',
    'WEEKDAY_WEDNESDAY',
    'WEEKDAY_THURSDAY',
    'WEEKDAY_FRIDAY',
    'WEEKDAY_SATURDAY',
    'WEEKDAY_SUNDAY',
]